import { AbstractFormElement, ICustomFormElement } from "./Abstract";
import { attachSubmitWithEnter } from "./helper/Form";

class InputText extends AbstractFormElement implements ICustomFormElement {
    attachEvents(): this {
        attachSubmitWithEnter.call(this);
        return super.attachEvents();
    }

    /**
     * initialize attributes
     */
    initAttributes() {
        if (this.hasAttribute("minlength")) {
            this.minlength = this.getAttribute("minlength");
        }
        if (this.hasAttribute("maxlength")) {
            this.maxlength = this.getAttribute("maxlength");
        }
        if (this.hasAttribute("pattern")) {
            this.pattern = this.getAttribute("pattern");
        }
        if (this.hasAttribute("type")) {
            this.type = this.getAttribute("type");
        }
        if (this.hasAttribute("min")) {
            this.min = this.getAttribute("min");
        }
        if (this.hasAttribute("max")) {
            this.max = this.getAttribute("max");
        }
        if (this.hasAttribute("step")) {
            this.step = this.getAttribute("step");
        }
        if (this.hasAttribute("inputmode")) {
            this.inputmode = this.getAttribute("inputmode");
        }
        return super.initAttributes();
    }

    setSelectionRange(start: number, end: number, direction?: "forward" | "backward" | "none") {
        this.input.setSelectionRange(start, end, direction);
    }

    get minlength() {
        return this.input.getAttribute("minlength");
    }

    set minlength(v) {
        this.input.setAttribute("minlength", v);
    }

    get maxlength() {
        return this.input.getAttribute("maxlength");
    }

    set maxlength(v) {
        this.input.setAttribute("maxlength", v);
    }

    get pattern() {
        return this.input.getAttribute("pattern");
    }

    set pattern(v) {
        if (!v && this.input.hasAttribute("pattern")) {
            this.input.removeAttribute("pattern");
        } else {
            this.input.setAttribute("pattern", v);
        }
    }

    get type() {
        return this.input.getAttribute("type");
    }

    set type(v) {
        if (!v && this.input.hasAttribute("type")) {
            this.input.removeAttribute("type");
        } else {
            this.input.setAttribute("type", v);
        }
    }

    get min() {
        return this.input.getAttribute("min");
    }

    set min(v) {
        if (!v && this.input.hasAttribute("min")) {
            this.input.removeAttribute("min");
        } else {
            this.input.setAttribute("min", v);
        }
    }

    get max() {
        return this.input.getAttribute("max");
    }

    set max(v) {
        if (!v && this.input.hasAttribute("max")) {
            this.input.removeAttribute("max");
        } else {
            this.input.setAttribute("max", v);
        }
    }

    get step() {
        return this.input.getAttribute("step");
    }

    set step(v) {
        if (!v && this.input.hasAttribute("step")) {
            this.input.removeAttribute("step");
        } else {
            this.input.setAttribute("step", v);
        }
    }

    get inputmode() {
        return this.input.getAttribute("inputmode");
    }

    set inputmode(v) {
        if (!v && this.input.hasAttribute("inputmode")) {
            this.input.removeAttribute("inputmode");
        } else {
            this.input.setAttribute("inputmode", v);
        }
    }

    get selectionDirection() {
        return this.input.selectionDirection;
    }

    get selectionStart() {
        return this.input.selectionStart;
    }

    get selectionEnd() {
        return this.input.selectionEnd;
    }
}

InputText.prototype.template = document.createElement("template");

InputText.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-input", InputText);

export { InputText };
